import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from '../components/ProtectedRoute';
import MobileLayout from './MobileLayout';
import MobileLogin from './pages/MobileLogin';
import MobileRegister from './pages/MobileRegister';
import MobileTopicRecords from './pages/MobileTopicRecords';
import MobileTradeRecords from './pages/MobileTradeRecords';
import MobileWelcome from './pages/MobileWelcome';
import MobileMasterData from './pages/MobileMasterData';
import MobilePermissionManagement from './pages/MobilePermissionManagement';

import Dashboard from '../pages/Dashboard';
import PermissionManagement from '../pages/PermissionManagement';
import Webhooks from '../pages/Webhooks';
import { authAPI } from '../services/api';

const MobileHomeRedirect = () => {
  const [to, setTo] = useState(null);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      try {
        const resp = await authAPI.me();
        const me = resp?.data || {};
        const isAdmin = !!me?.is_admin;
        const roleName = String(me?.role_name || '').toUpperCase();
        if (mounted) {
          if (isAdmin) setTo('/master-data');
          else if (roleName === 'CHECK_USER') setTo('/topic-records');
          else setTo('/welcome');
        }
      } catch (e) {
        if (mounted) setTo('/login');
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, []);

  if (!to) return null;
  return <Navigate to={to} replace />;
};

function MobileApp() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<MobileLogin />} />
        <Route path="/register" element={<MobileRegister />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MobileLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<MobileHomeRedirect />} />

          <Route path="welcome" element={<MobileWelcome />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="master-data" element={<MobileMasterData />} />
          <Route path="permissions" element={<MobilePermissionManagement />} />
          <Route path="permission" element={<PermissionManagement />} />
          <Route path="webhooks" element={<Webhooks />} />

          <Route path="topic-records" element={<MobileTopicRecords />} />
          <Route path="trade-records" element={<MobileTradeRecords />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default MobileApp;
